export const SPACE_RIGHT_ADMIN = 1 << 0;
export const SPACE_RIGHT_WRITE = 1 << 1;
export const SPACE_RIGHT_READ = 1 << 2;
export const SPACE_RIGHT_MEMBER = SPACE_RIGHT_READ | SPACE_RIGHT_WRITE;

export const spaceRightNames = {
  [SPACE_RIGHT_ADMIN]: "Admin",
  [SPACE_RIGHT_WRITE]: "Write",
  [SPACE_RIGHT_READ]: "Read",
  [SPACE_RIGHT_MEMBER]: "Member"
};

export const ORGANIZATION_RIGHT_OWNER = 1 << 0;
export const ORGANIZATION_RIGHT_COOWNER = 1 << 1;
export const ORGANIZATION_RIGHT_WRITE = 1 << 2;
export const ORGANIZATION_RIGHT_READ = 1 << 3;

// export const ORGANIZATION_RIGHT_ADMIN = 1 << 1;
// export const ORGANIZATION_RIGHT_READ = 1 << 2;
// export const ORGANIZATION_RIGHT_SPACE_ADMIN = 1 << 3;
// export const ORGANIZATION_RIGHT_SPACE_WRITE = 1 << 4;
// export const ORGANIZATION_RIGHT_SPACE_READ = 1 << 5;

export const organizationRightNames = {
  [ORGANIZATION_RIGHT_OWNER]: "owner",
  [ORGANIZATION_RIGHT_COOWNER]: "coowner",
  [ORGANIZATION_RIGHT_WRITE]: "write",
  [ORGANIZATION_RIGHT_READ]: "read"
  // [ORGANIZATION_RIGHT_ADMIN]: "admin",
  // [ORGANIZATION_RIGHT_SPACE_ADMIN]: "space-admin",
  // [ORGANIZATION_RIGHT_SPACE_WRITE]: "space-write",
  // [ORGANIZATION_RIGHT_SPACE_READ]: "space-read"
};

export const MODULE_CALC_1 = 1 << 0;
export const MODULE_CALC_2 = 1 << 1;
export const MODULE_CALC_3 = 1 << 2;
export const MODULE_CALC_CO2 = 1 << 3;
export const MODULE_COLLAB = 1 << 4;
export const MODULE_SPACE = 1 << 5;
export const MODULE_SPACE_UNLIMITED = 1 << 6;

export const MODULES = {
  [MODULE_CALC_1]: {
    module: "Level 1 Kalkulation",
    description: "Description for Level 1 Kalkulation",
    active: true,
    price: 0,
    id: MODULE_CALC_1
  },
  [MODULE_CALC_2]: {
    module: "Level 2 Kalkulation",
    description: "Description for Level 2 Kalkulation",
    active: false,
    price: 499,
    id: MODULE_CALC_2
  },
  [MODULE_CALC_3]: {
    module: "Level 3 Kalkulation",
    description: "Description for Level 3 Kalkulation",
    active: false,
    price: 499,
    id: MODULE_CALC_3
  },
  [MODULE_CALC_CO2]: {
    module: "CO2 Kalkulation",
    description: "Description for CO2 Kalkulation",
    active: false,
    price: 499,
    id: MODULE_CALC_CO2
  },
  [MODULE_COLLAB]: {
    module: "Kollaboration",
    description: "Description for Kollaboration",
    active: false,
    price: 699,
    id: MODULE_COLLAB
  },
  [MODULE_SPACE]: {
    module: "Kalkulationsräume",
    description: "Description for Kalkulationsräume",
    active: false,
    price: 299,
    id: MODULE_SPACE
  },
  [MODULE_SPACE_UNLIMITED]: {
    module: "Kalkulationsräume unlimited",
    description: "Description for Kalkulationsräume unlimited",
    active: false,
    price: 599,
    id: MODULE_SPACE_UNLIMITED
  }
};
